import p5 from 'p5';
import * as espree from 'espree';
import * as jsBeautify from 'js-beautify';
import fs from 'fs';
import hljs from 'highlight.js';

export const params = new Proxy(new URLSearchParams(window.location.search), {
	get: (searchParams, prop) => searchParams.get(prop),
});
export const isRender = params.render;

// P5Capture does not support module bundlers so I will disable it.
//
//P5Capture.setDefaultOptions({
//	format: "png",
//	framerate: 30,
//	width: 1080,
//	height: 1080,
//	duration: maxFrames,
//	disableUi: !isRender,
//});

export function escapeHtml(unsafe) {
	return unsafe
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#039;");
}

const customFns = [];
export function registerCommonFn(fn) {
	customFns.push(fn);
}

let sketchSource = '';
window.onload = () => {
  const commons = fs.readFileSync(__dirname + '/common.js', 'utf8');
	document.getElementById('code-sketch').innerHTML = escapeHtml(sketchSource);
	document.getElementById('code-commons').innerHTML = escapeHtml(formatSource(commons));

	hljs.highlightAll();
};

function formatSource(source) {
  const ast = espree.parse(source, { ecmaVersion: 'latest', sourceType: 'module' });
  const imports = ast.body.filter(topLevel => topLevel.type == "ImportDeclaration");

  const [start, end] = imports.reduce(
    ([start, end], curr) => [Math.min(start, curr.start), Math.max(end, curr.end)], 
    [Number.MAX_VALUE, Number.MIN_VALUE]);
  const left = source.slice(0, start);
  const right = source.slice(end, source.length);
  const cleanedUpSource = (left + right).trim();

  const formattedSource = jsBeautify(cleanedUpSource, {
    indent_size: 2,
  });

  return formattedSource;
} 


export function make(p5Fns, source) {
  for (const [key, value] of Object.entries(p5Fns)) {
    window[key] = value;
  }
  new p5();

  sketchSource = formatSource(source);
}
